import { useQuery } from '@tanstack/react-query';
import ISearchCriteria from '@models/dto/searchCriteria.dto';
import IPaginatedParams from '@models/paginated-params';
import { getJobById, getJobs } from '@jobs/services/jobsServices';

export const useGetJobs = (
  paginatedParams: IPaginatedParams,
  searchCriteria: ISearchCriteria,
  enabled: boolean = true,
) => {
  return useQuery({
    queryKey: ['jobs', paginatedParams, searchCriteria],
    queryFn: () => getJobs(paginatedParams, searchCriteria),
    enabled,
  });
};

export const useGetJobById = (id: string, enabled: boolean = true) => {
  return useQuery({
    queryKey: ['job', id],
    queryFn: () => getJobById(id),
    enabled,
  });
};
